import { useMemo } from 'react';
import {
  getSelectedProposalExecutionState,
  type ProposalExecutionCandidate,
  type SelectedProposalExecutionState,
} from '@/utils/SignatureCountsHelpers';

/**
 * Keeps batch readiness synchronized with both polled proposals and the current
 * UI selection. Each caller supplies its own mapper because proposal APIs store
 * their required networks in different fields.
 */
export function useSelectedProposalExecutionState<T>(
  proposals: T[],
  selectedIds: string[],
  toExecutionCandidate: (proposal: T) => ProposalExecutionCandidate
): SelectedProposalExecutionState {
  // Recompute readiness when polling or selection changes so stale state cannot
  // start an execution that is no longer valid.
  return useMemo(
    () =>
      getSelectedProposalExecutionState(
        proposals.map(toExecutionCandidate),
        selectedIds
      ),
    [proposals, selectedIds, toExecutionCandidate]
  );
}
